'use client';

import { Spin } from 'antd';
import * as React from 'react';

export const CustomSpin = () => (
  <Spin
    data-testid='custom-spin'
    size='large'
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
    }}
  />
);
